// extracted by mini-css-extract-plugin
export default {"icon":"VerificationFailure_icon--BYm","tryAgainButton":"VerificationFailure_tryAgainButton--jps"};